meedy.controller('meedy.verificationController', ['$scope', '$rootScope', '$state', '$stateParams', '$timeout', 'meedy.objectHelper', 'applicationModel', 'meedy.authModel', 'meedy.userModel', '$translate',
    function ($scope, $rootScope, $state, $stateParams, $timeout, objectHelper, applicationModel, authModel, userModel, $translate) {

        function setData() {
            $scope.uuid = $stateParams.uuid;

            $scope.authenticationError = false;
            $scope.success = false;
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.MEEDY.USER.CONFIRM_PHYSICIAN.SUCCESS, function (event, data) {
                $scope.success = true;
            });

            $scope.$on(Event.MEEDY.USER.CONFIRM_PHYSICIAN.ERROR, function (event, error) {
                $scope.authenticationError = true;
            });
        }

        function setActions() {
            $scope.goToLogin = function() {
                $state.go(Constant.STATE.PRE.MEEDY.LOGIN);
            };
        }

        function configureInterface() {
        }

        function initialize() {
            $timeout(function(){
                applicationModel.viewReady = true;
                userModel.confirmPhysician($scope.uuid);
            });
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
